import React from 'react';

import { capitalize } from 'lodash';

import { client } from '@admin/libraries/apollo';
import { useAccountOrderCancellationGroupQuery } from '@admin/schema';

export const OrderCancellationPolicies: React.FC<{ accountID: number }> = ({ accountID }) => {
  const { data } = useAccountOrderCancellationGroupQuery({ client, variables: { accountID: String(accountID) } });
  if (!data?.account.orderCancellationPolicyGroup) {
    return null;
  }
  return (
    <>
      <div>
        <strong>Order Cancellation Policy:</strong>
      </div>
      <ul>
        {data.account.orderCancellationPolicyGroup.policies.map((policy, pkey) => (
          <li key={`cancellation-policy-${pkey}`}>
            {capitalize(policy.orderType)} - {capitalize(policy.orderSubtype)}:
            <ul>
              {policy.summaries.map((summary, skey) => (
                <li key={`cancellation-policy-summary-${skey}`}>{summary}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </>
  );
};
